module.exports = {
  store: 'http://v2.redis-store.com'
}


// WEBPACK FOOTER //
// ./src/web/web.config.js